/* global ga */
import Immutable from 'immutable';
import Fluxxor from 'fluxxor';
import URI from 'URIjs';

import moment from 'ofs/moment';

function pushWithLimit(array, value, limit=10) {
  array.push(value);

  if (array.length > limit) {
    let diff = array.length - limit;
    array.splice(0, diff);
  }

  return array;
}

export function filtersToParams(filters) {
  const filterMap = {
    'city': (city) => city.get('region_id'),
    'currency': (currency) => currency.get('iso_4217'),
    'region': (region) => region.get('id'),
    'folio': (folio) => folio.get('slug'),
    'sleeps': (sleeps) => sleeps === 0 ? null : sleeps,
    'bedrooms': (bedrooms) => bedrooms === 0 ? null : bedrooms,
    'promotion': (promotion) => promotion.get('slug'),
    'tags': (tags) => tags.toArray()
  };

  let params = filters.reduce((result, value, filter) => {
    if (value !== null) {
      if (typeof filterMap[filter] !== 'undefined') {
        value = filterMap[filter](value);
      }

      // check again that the value is not null
      if (value !== null) {
        result = result.set(filter, value);
      }
    }
    return result;
  }, Immutable.Map());

  return params;
}

const SearchStore = Fluxxor.createStore({
  initialize(options) {
    this.bindActions(
      'SEARCH_UPDATE_FILTERS', this.onUpdateFilters,
      'SEARCH_UPDATE_FILTERS_SUCCESS', this.onUpdateFiltersSuccess,
      'SEARCH_UPDATE_FILTERS_FAIL', this.onUpdateFiltersFail,
      'SEARCH_CANCEL_HOME_SEARCH', this.onCancelHomeSearch,
      'SEARCH_ADD_TAG', this.onAddTag,
      'SEARCH_REMOVE_TAG', this.onRemoveTag
    );
    this.state = Immutable.fromJS(options);

    this.history = [];
  },

  getState() {
    return this.state;
  },

  getContext() {
    return this.state.get('context');
  },

  onUpdateFilters(payload) {
    const filters = this.getContext().get('filters').merge(Immutable.fromJS(payload));

    // keep track of search history
    pushWithLimit(this.history, this.state);

    this.state = this.state
      .setIn(['context', 'filters'], filters)
      .set('loading', true);

    this.emit('change');
  },

  onUpdateFiltersSuccess(payload) {
    this.state = this.state
      .set('context', Immutable.fromJS(payload))
      .set('loading', false);

    this.emit('change');

    // send google search event
    this.sendGoogleSearchEvent();
  },

  onUpdateFiltersFail(error) {
    throw error;
  },

  onCancelHomeSearch() {
    // TODO check if previous search
    this.state = this.state
      .setIn(['context', 'filters', 'title'], null)
      .set('loading', 'true');

    this.emit('change');
  },

  onAddTag(tagId) {
    let filters = this.state.getIn(['context', 'filters']);

    const tags = filters.get('tags');
    filters = filters
      .set('tags', tags.push(tagId))
      .merge(Immutable.Map({
        'page': 1
      }));

    this.state = this.state
      .setIn(['context', 'filters'], filters)
      .set('loading', true);

    this.emit('change');
  },

  onRemoveTag(tagId) {
    let filters = this.state.getIn(['context', 'filters']);

    let tags = filters.get('tags');
    const tagIndex = tags.indexOf(tagId);
    if (tagIndex > -1) {
      tags = tags.remove(tagIndex);
    }

    filters = filters
      .set('tags', tags)
      .merge(Immutable.Map({
        'page': 1
      }));

    this.state = this.state
      .setIn(['context', 'filters'], filters)
      .set('loading', true);

    this.emit('change');
  },

  getParams() {
    const filters = this.getContext().get('filters');
    return filtersToParams(filters).toJS();
  },

  sendGoogleSearchEvent() {
    if (__BROWSER__) {
      const params = this.getParams();
      const filters = this.getContext().get('filters');
      const results = this.getContext().get('results');
      const today = moment().format("DD/MM/YY");

      const url = new URI(window.location.origin + window.location.pathname)
        .addQuery(params)
        .addQuery({
          'searched_at': today,
        });

      if (filters.get('start_date') && filters.get('end_date')) {
        const start = moment(filters.get('start_date')).startOf('day');
        const end = moment(filters.get('end_date')).startOf('day');
        const difference = Math.abs(start.diff(end, 'days'));
        url.addQuery({'stay_length': difference});
      }

      /* eslint-disable no-empty */
      try {
        ga('set', 'dimension5', results.get('total').toString());
        ga('send', 'event', 'Search', 'Performed', url.toString(), results.get('total'));
      } catch (err) {}
      /* eslint-enable no-empty */
    }
  },
});

export default SearchStore;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/search/stores/SearchStore.js
 **/